var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15553_160195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H22.4996V22.4995H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15553_160195)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35908 5.06018C4.36108 5.06018 4.31108 5.11218 4.24808 5.17418C4.00608 5.40918 3.50508 5.89818 3.50008 6.92118C3.49208 8.35218 4.43308 11.0092 8.96408 15.5392C13.4741 20.0472 16.1271 20.9992 17.5611 20.9992H17.5821C18.6051 20.9942 19.0931 20.4922 19.3291 20.2512C19.4011 20.1772 19.4591 20.1232 19.5001 20.0892C20.4961 19.0872 21.0061 18.3412 21.0011 17.8632C20.9941 17.3752 20.3871 16.7982 19.5481 16.0002C19.2811 15.7462 18.9911 15.4702 18.6851 15.1642C17.8921 14.3732 17.4991 14.5082 16.6351 14.8122C15.4401 15.2312 13.8001 15.8012 11.2521 13.2522C8.70008 10.7022 9.27108 9.06418 9.68908 7.86918C9.99108 7.00518 10.1291 6.61118 9.33508 5.81718C9.02408 5.50718 8.74508 5.21318 8.48808 4.94318C7.69508 4.10918 7.12308 3.50618 6.63808 3.49918H6.63008C6.15108 3.49918 5.40708 4.01118 4.35408 5.06418C4.35708 5.06118 4.35808 5.06018 4.35908 5.06018ZM17.5621 22.4992C15.0701 22.4992 11.8211 20.5152 7.90408 16.6002C3.97208 12.6692 1.98508 9.41018 2.00008 6.91318C2.00908 5.26318 2.87408 4.41818 3.19908 4.10118C3.21608 4.08018 3.27408 4.02318 3.29408 4.00318C4.72808 2.56818 5.69508 1.98818 6.65708 1.99918C7.77408 2.01418 8.56908 2.85018 9.57508 3.90918C9.82408 4.17118 10.0941 4.45618 10.3951 4.75618C11.8551 6.21618 11.4391 7.40718 11.1051 8.36318C10.7411 9.40618 10.4261 10.3062 12.3121 12.1922C14.2001 14.0782 15.1001 13.7632 16.1391 13.3962C17.0961 13.0622 18.2841 12.6442 19.7461 14.1042C20.0421 14.4002 20.3231 14.6672 20.5821 14.9142C21.6461 15.9252 22.4861 16.7242 22.5001 17.8442C22.5121 18.7992 21.9321 19.7722 20.5001 21.2052L19.8661 20.7752L20.4021 21.2992C20.0851 21.6242 19.2411 22.4902 17.5901 22.4992H17.5621Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e01d00865e83bd725ba8857db482369a.svg";
export { ForwardRef as ReactComponent };